// react
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// components
import Calendar from './Calendar.jsx'
import { Icon } from '@st-operations/uikit/src/v2/index.js'

// css
import './MonthPicker.scss'

// constants
const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

// component
class MonthPicker extends Component {
  constructor(props) {
    super(props)

    this.wrapperRef = React.createRef()
    this.calendarRef = React.createRef()
    this.state = {
      currentYear: Number(props.value?.split('-')?.[0]) || null,
      isCalendarOpen: false,
      top: 0,
      left: 0,
    }
  }

  handleCloseCalendar = () => {
    this.setState({ isCalendarOpen: false })
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target) &&
      this.calendarRef.current &&
      !this.calendarRef.current.contains(event.target)
    ) {
      this.handleCloseCalendar()
    }
  }

  componentDidMount() {
    const { from, to } = this.props
    const firstYear = Number(from.split('-')[0])
    const finalYear = Number(to.split('-')[0])
    const years = [...Array(finalYear - firstYear + 1).keys()].map((_, index) => index + firstYear)

    document.addEventListener('mousedown', this.handleClickOutside)
    this.setState({
      currentYear: this.props.beginByLastYear ? years[years.length - 1] : years[0],
      years,
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  formattedValue = (value) => {
    const [year, month] = value.split('-')
    return `${month}/${year}`
  }

  handleOpenCalendar = () => {
    const { bottom, left } = this.wrapperRef.current.getBoundingClientRect()

    this.setState({
      bottom: window.innerHeight - bottom + (this.props.popupDirectionBottom ? -300 : 56),
      isCalendarOpen: true,
      left,
    })
  }

  handleNextYear = () => {
    this.setState((prevState) => ({ currentYear: prevState.currentYear + 1 }))
  }

  handlePreviousYear = () => {
    this.setState((prevState) => ({ currentYear: prevState.currentYear - 1 }))
  }

  handleSelectMonth = (event) => {
    const { currentYear } = this.state
    const { name, onChange } = this.props
    const { value: selectedMonth } = event.currentTarget

    const newValue = `${currentYear}-${('0' + (Number(selectedMonth) + 1)).slice(-2)}-01`

    onChange(name, newValue)
    this.handleCloseCalendar()
  }

  renderCalendar = () => {
    const { currentYear, years, bottom, left } = this.state
    const { from, to, value } = this.props

    const [lastYear, lastMonth] = to.split('-')
    const [firstYear, firstMonth] = from.split('-')
    const isFirstYear = Number(firstYear) === currentYear
    const isLastYear = Number(lastYear) === currentYear
    const hasMultipleYears = years.length > 1
    const [activeYear, activeMonth] = value.split('-')

    const isMonthDisabled = (index) => {
      if (hasMultipleYears) {
        if (isFirstYear) {
          return index < Number(firstMonth) - 1
        } else if (isLastYear) {
          return index > Number(lastMonth) - 1
        }
        return false
      }

      return index < Number(firstMonth) || index > Number(firstMonth)
    }

    return (
      <Calendar
        bottom={bottom}
        currentYear={currentYear}
        hasArrows={hasMultipleYears}
        isFirstYear={isFirstYear}
        isLastYear={isLastYear}
        left={left}
        onNextYear={this.handleNextYear}
        onPreviousYear={this.handlePreviousYear}
        ref={this.calendarRef}
      >
        <For each="month" index="index" of={MONTHS}>
          <button
            className={`month-picker__month ${
              Number(activeMonth) === index + 1 && Number(activeYear) === currentYear
                ? 'active'
                : ''
            }`}
            disabled={isMonthDisabled(index)}
            key={`${currentYear}-${month}`}
            onClick={this.handleSelectMonth}
            value={index}
          >
            {month}
          </button>
        </For>
      </Calendar>
    )
  }

  render() {
    const { isCalendarOpen } = this.state
    const { value } = this.props

    return (
      <div className="month-picker" ref={this.wrapperRef}>
        <div className="month-picker__input-container">
          <input
            className="month-picker__input"
            onClick={this.handleOpenCalendar}
            readOnly
            type="text"
            value={this.formattedValue(value)}
          />
          <div className="month-picker__input-icon-container">
            <Icon className="month-picker__input-icon" height="24px" icon="calendar" width="24px" />
          </div>
        </div>
        {isCalendarOpen && this.renderCalendar()}
      </div>
    )
  }
}

MonthPicker.propTypes = {
  // String date on 'yyyy-mm-dd' format
  from: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  to: PropTypes.string,
  value: PropTypes.string,
}

MonthPicker.defaultProps = {}

// export
export default MonthPicker
